/* eslint-disable */
import { useState, useEffect } from "react";
import LoginPage from "./login";
import CRM from "./wholesale-crm";
import Dashboard from "./Dashboard";
import Outreach from "./Outreach";
import Prospects from "./Prospects";
import Settings from "./Settings";
import IntakeForm from "./IntakeForm";

import { supabase } from "./supabaseClient";

function fromRow(r){return{id:r.id,stage:r.stage,name:r.name,phone:r.phone,address:r.address,sqft:r.sqft,equity:r.equity,taxLien:r.tax_lien,vacant:r.vacant,score:r.score,hot:r.hot,notes:r.notes,arv:r.arv,comps:r.comps||[],rehabTier:r.rehab_tier,conditionReport:r.condition_report,smsHistory:r.sms_history||[],followUps:r.follow_ups||[],lastContact:r.last_contact,wholesaleFee:r.wholesale_fee||null,propertyType:r.property_type||"Single Family",market:r.market||""};}

function useMobile(){
  const [m,setM]=useState(()=>window.innerWidth<768);
  useEffect(()=>{const h=()=>setM(window.innerWidth<768);window.addEventListener("resize",h);return()=>window.removeEventListener("resize",h);},[]);
  return m;
}


// ─── Accept Invite Page ───────────────────────────────────────────────────────
function AcceptInvitePage({ token }) {
  const [step, setStep] = useState("form"); // "form" | "loading" | "done" | "error"
  const [mode, setMode] = useState("signup"); // "signup" | "login"
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://wholesaleiq-backend-production-aedc.up.railway.app";

  const handleSubmit = async () => {
    if (!email || !password) { setErrorMsg("Email and password are required."); return; }
    setStep("loading"); setErrorMsg("");
    try {
      let userId;

      if (mode === "signup") {
        const { data, error } = await supabase.auth.signUp({ email, password });
        // If user already exists, auto-switch to login mode
        if (error) {
          if (error.message.toLowerCase().includes("already") || error.message.toLowerCase().includes("registered")) {
            setMode("login");
            setErrorMsg("You already have an account — sign in below to join the team.");
            setStep("form");
            return;
          }
          throw error;
        }
        userId = data.user?.id;
        // Supabase returns a user but with no session if email confirmation is required
        if (!userId) {
          setMode("login");
          setErrorMsg("Account created! Check your email to confirm, then sign in below.");
          setStep("form");
          return;
        }
      } else {
        const { data, error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
        userId = data.user?.id;
      }

      // Call backend to link user to team
      const res = await fetch(`${BACKEND_URL}/api/accept-invite`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, userId }),
      });
      const result = await res.json();
      if (!result.success) throw new Error(result.error || "Failed to accept invite");

      setStep("done");
      setTimeout(() => { window.location.href = "/"; }, 2000);

    } catch (e) {
      setErrorMsg(e.message);
      setStep("form");
    }
  };

  const inp = {
    width: "100%", padding: "13px 14px",
    background: "#111113", border: "1px solid #1C1C1F",
    borderRadius: 8, color: "#E8E6E1", fontSize: 15,
    outline: "none", boxSizing: "border-box", marginBottom: 12,
    fontFamily: "'DM Sans', sans-serif",
  };

  if (step === "loading") return (
    <div style={{ background: "#0A0A0B", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16 }}>
      <div style={{ width: 32, height: 32, border: "2px solid #1C1C1F", borderTopColor: "#C9A96E", borderRadius: "50%", animation: "spin .7s linear infinite" }} />
      <div style={{ fontSize: 12, color: "#45454A", fontFamily: "'DM Mono',monospace", letterSpacing: 2 }}>SETTING UP YOUR ACCOUNT...</div>
      <style>{"@keyframes spin{to{transform:rotate(360deg)}}"}</style>
    </div>
  );

  if (step === "done") return (
    <div style={{ background: "#0A0A0B", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16, fontFamily: "'DM Sans',sans-serif" }}>
      <div style={{ fontSize: 64 }}>✅</div>
      <div style={{ fontSize: 9, letterSpacing: 3, color: "#C9A96E", fontFamily: "'DM Mono',monospace" }}>WHOLESALEIQ</div>
      <h2 style={{ color: "#E8E6E1", fontSize: 24, margin: 0, fontWeight: 800 }}>You're in!</h2>
      <p style={{ color: "#6B6B70", margin: 0 }}>Redirecting you to the CRM...</p>
    </div>
  );

  return (
    <div style={{ background: "#0A0A0B", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 20, fontFamily: "'DM Sans',sans-serif" }}>
      <div style={{ width: "100%", maxWidth: 420, background: "#111113", border: "1px solid #1C1C1F", borderRadius: 16, padding: 32, boxShadow: "0 30px 80px #0009" }}>
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{ fontSize: 9, letterSpacing: 3, color: "#C9A96E", fontFamily: "'DM Mono',monospace", marginBottom: 8 }}>WHOLESALEIQ</div>
          <h1 style={{ color: "#E8E6E1", fontSize: 22, margin: "0 0 8px", fontWeight: 800 }}>You've been invited!</h1>
          <p style={{ color: "#6B6B70", fontSize: 14, margin: 0 }}>{mode === "signup" ? "Create an account to join your team." : "Sign in to accept your team invite."}</p>
        </div>

        {/* Toggle signup/login */}
        <div style={{ display: "flex", background: "#0F0F11", borderRadius: 8, padding: 4, marginBottom: 24 }}>
          {[["signup","Create Account"],["login","I Have an Account"]].map(([m, label]) => (
            <button key={m} onClick={() => setMode(m)}
              style={{ flex: 1, padding: "8px", background: mode === m ? "#1C1C1F" : "none", border: "none", borderRadius: 6, color: mode === m ? "#C9A96E" : "#45454A", fontSize: 12, cursor: "pointer", fontWeight: mode === m ? 700 : 400, fontFamily: "'DM Mono',monospace" }}>
              {label}
            </button>
          ))}
        </div>

        <input style={inp} placeholder="Email address" type="email" value={email} onChange={e => setEmail(e.target.value)} />
        <input style={{ ...inp, marginBottom: 20 }} placeholder="Password" type="password" value={password} onChange={e => setPassword(e.target.value)}
          onKeyDown={e => e.key === "Enter" && handleSubmit()} />

        {errorMsg && (
          <div style={{ background: "#C0614911", border: "1px solid #C0614933", borderRadius: 8, padding: "10px 14px", marginBottom: 16, color: "#C06149", fontSize: 13 }}>
            ⚠ {errorMsg}
          </div>
        )}

        <button onClick={handleSubmit}
          style={{ width: "100%", padding: "14px", background: "linear-gradient(135deg,#C9A96E,#A8834A)", border: "none", borderRadius: 8, color: "#0F0F11", fontWeight: 800, fontSize: 15, cursor: "pointer", fontFamily: "'DM Mono',monospace", letterSpacing: 1 }}>
          {mode === "signup" ? "CREATE ACCOUNT & JOIN" : "SIGN IN & JOIN"}
        </button>
      </div>
    </div>
  );
}



// ─── Reset Password Page ──────────────────────────────────────────────────────
function ResetPasswordPage() {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const handleReset = async () => {
    if (!password) { setError("Enter a new password."); return; }
    if (password.length < 6) { setError("Password must be at least 6 characters."); return; }
    if (password !== confirm) { setError("Passwords do not match."); return; }
    setLoading(true); setError("");
    const { error: updateError } = await supabase.auth.updateUser({ password });
    setLoading(false);
    if (updateError) { setError(updateError.message); return; }
    setDone(true);
    setTimeout(() => { window.location.href = "/"; }, 2500);
  };

  const inp = {
    width:"100%", padding:"13px 14px", background:"#111113",
    border:"1px solid #1C1C1F", borderRadius:8, color:"#E8E6E1",
    fontSize:15, outline:"none", boxSizing:"border-box", marginBottom:12,
    fontFamily:"'DM Sans',sans-serif",
  };

  if (done) return (
    <div style={{ background:"#0A0A0B", minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:16, fontFamily:"'DM Sans',sans-serif" }}>
      <div style={{ fontSize:64 }}>✅</div>
      <div style={{ fontSize:9, letterSpacing:3, color:"#C9A96E", fontFamily:"'DM Mono',monospace" }}>WHOLESALEIQ</div>
      <h2 style={{ color:"#E8E6E1", fontSize:24, margin:0, fontWeight:800 }}>Password updated!</h2>
      <p style={{ color:"#6B6B70", margin:0 }}>Redirecting you to sign in...</p>
    </div>
  );

  return (
    <div style={{ background:"#0A0A0B", minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", padding:20, fontFamily:"'DM Sans',sans-serif" }}>
      <div style={{ width:"100%", maxWidth:420, background:"#111113", border:"1px solid #1C1C1F", borderRadius:16, padding:32, boxShadow:"0 30px 80px #0009" }}>
        <div style={{ textAlign:"center", marginBottom:28 }}>
          <div style={{ fontSize:9, letterSpacing:3, color:"#C9A96E", fontFamily:"'DM Mono',monospace", marginBottom:8 }}>WHOLESALEIQ</div>
          <h1 style={{ color:"#E8E6E1", fontSize:22, margin:"0 0 8px", fontWeight:800 }}>Set New Password</h1>
          <p style={{ color:"#6B6B70", fontSize:14, margin:0 }}>Choose a strong password for your account.</p>
        </div>

        <div style={{ marginBottom:12 }}>
          <label style={{ display:"block", fontSize:11, fontFamily:"'DM Mono',monospace", color:"#64748B", letterSpacing:1, marginBottom:7 }}>NEW PASSWORD</label>
          <input type="password" style={inp} placeholder="Min. 6 characters" value={password} onChange={e=>setPassword(e.target.value)} />
        </div>
        <div style={{ marginBottom:20 }}>
          <label style={{ display:"block", fontSize:11, fontFamily:"'DM Mono',monospace", color:"#64748B", letterSpacing:1, marginBottom:7 }}>CONFIRM PASSWORD</label>
          <input type="password" style={{...inp, marginBottom:0}} placeholder="Repeat password" value={confirm}
            onChange={e=>setConfirm(e.target.value)}
            onKeyDown={e=>e.key==="Enter"&&handleReset()} />
        </div>

        {error && (
          <div style={{ background:"#C0614911", border:"1px solid #C0614933", borderRadius:8, padding:"10px 14px", marginBottom:16, color:"#C06149", fontSize:13 }}>
            ⚠ {error}
          </div>
        )}

        <button onClick={handleReset} disabled={loading}
          style={{ width:"100%", padding:"14px", background:"linear-gradient(135deg,#C9A96E,#A8834A)", border:"none", borderRadius:8, color:"#0F0F11", fontWeight:800, fontSize:15, cursor:"pointer", fontFamily:"'DM Mono',monospace", opacity:loading?0.6:1 }}>
          {loading ? "UPDATING..." : "UPDATE PASSWORD →"}
        </button>
      </div>
    </div>
  );
}

// ─── Trial Banner ────────────────────────────────────────────────────────────
function TrialBanner({ subscription, currentUser }) {
  const [dismissed, setDismissed] = useState(false);
  const days = subscription?.trialDaysLeft;
  const isTrialing = subscription?.status === "trialing";
  const isExpired = isTrialing && days === 0;
  const isUrgent = isTrialing && days !== null && days <= 5;

  if (!isTrialing || dismissed) return null;

  const checkout = async () => {
    const BACKEND = process.env.REACT_APP_BACKEND_URL || "https://wholesaleiq-backend-production-aedc.up.railway.app";
    try {
      const res = await fetch(`${BACKEND}/api/stripe/checkout`, {
        method: "POST", headers: {"Content-Type":"application/json"},
        body: JSON.stringify({ tier:"pro", userId:currentUser?.id, email:currentUser?.email,
          successUrl: window.location.href + "?billing=success",
          cancelUrl: window.location.href }),
      });
      const data = await res.json();
      if (data.url) window.location.href = data.url;
    } catch(e) { console.error(e); }
  };

  const bg = isExpired ? "#C06149" : isUrgent ? "#C9935A" : "#C9A96E";
  const msg = isExpired ? "Your trial has ended — subscribe to continue"
    : days === 1 ? "1 day left in your free Starter trial"
    : `${days} days left in your free Starter trial`;

  return (
    <div style={{background:bg+"18",borderBottom:`1px solid ${bg}33`,padding:"8px 24px",display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0}}>
      <div style={{display:"flex",alignItems:"center",gap:10}}>
        <span style={{fontSize:13}}>{isExpired?"⚠️":"⏳"}</span>
        <span style={{fontSize:11,color:bg,fontFamily:"'DM Mono',monospace",fontWeight:700,letterSpacing:1}}>{msg.toUpperCase()}</span>
      </div>
      <div style={{display:"flex",gap:8,alignItems:"center"}}>
        <button onClick={checkout} style={{background:bg,border:"none",borderRadius:6,color:"#0F0F11",padding:"5px 14px",fontSize:11,fontWeight:800,cursor:"pointer",fontFamily:"'DM Mono',monospace"}}>
          SUBSCRIBE →
        </button>
        {!isExpired&&<button onClick={()=>setDismissed(true)} style={{background:"none",border:"none",color:bg,fontSize:18,cursor:"pointer",padding:"0 4px",opacity:0.6,lineHeight:1}}>×</button>}
      </div>
    </div>
  );
}

export default function App(){
  const [user,setUser]=useState(null);
  const [showUpgrade,setShowUpgrade]=useState(false);
  const [subscription,setSubscription]=useState({tier:"starter",status:"none",limits:{leads:250,markets:1,rentcast:20}});
  const [role,setRole]=useState("owner");
  const [checking,setChecking]=useState(true);
  const [teamReady,setTeamReady]=useState(false);
  const [view,setView]=useState("dashboard");
  const [leads,setLeads]=useState([]);
  const [sel,setSel]=useState(null);
  const isMobile=useMobile();

  if(window.location.pathname==="/intake")return <IntakeForm/>;
  // Handle Supabase password reset — token arrives in URL hash
  const _hash = window.location.hash;
  if(_hash.includes("type=recovery")&&_hash.includes("access_token")) return <ResetPasswordPage/>;
  const _tok=new URLSearchParams(window.location.search).get("token");
  if(window.location.pathname==="/accept-invite"&&_tok)return <AcceptInvitePage token={_tok}/>;

  useEffect(()=>{
    supabase.auth.getSession().then(({data})=>{setUser(data.session?.user||null);setChecking(false);});
    const{data:l}=supabase.auth.onAuthStateChange((_,s)=>{if(!window._signingUp)setUser(s?.user||null);});
    return()=>l.subscription.unsubscribe();
  },[]);

  useEffect(()=>{
    if(!user?.id)return;
    (async()=>{
      let ownerIdToUse = user.id;
      try{
        const{data:m}=await supabase.from("team_members").select("role,team_id").eq("user_id",user.id).eq("status","active").maybeSingle();
        if(m){setRole(m.role);const{data:t}=await supabase.from("teams").select("owner_id").eq("id",m.team_id).maybeSingle();ownerIdToUse=t?.owner_id||user.id;setUser(u=>({...u,org_id:m.team_id,owner_id:ownerIdToUse}));}
      setTeamReady(true);
    }catch(e){console.warn("No team record:",e);setTeamReady(true);}
      try{
      const finalUserId=ownerIdToUse;
      const{data:d}=await supabase.from("leads").select("*").eq("user_id",finalUserId).order("created_at",{ascending:false});
      if(d)setLeads(d.map(fromRow));
    }catch(e){console.error("Leads load error:",e);}
      try{
      // Load subscription from owner's account (for team members, ownerIdToUse = owner's ID)
      const isOwner = ownerIdToUse === user.id;
      const{data:sub}=await supabase.from("subscriptions").select("*").eq("user_id",ownerIdToUse).maybeSingle();
      if(sub){
        const LIMITS={starter:{leads:250,markets:1,rentcast:20},pro:{leads:99999,markets:3,rentcast:75},team:{leads:99999,markets:99,rentcast:300}};
        let trialDaysLeft = null;
        if(sub.status === "trialing" && sub.trial_end) {
          const msLeft = new Date(sub.trial_end) - new Date();
          trialDaysLeft = Math.max(0, Math.ceil(msLeft / (1000 * 60 * 60 * 24)));
        }
        setSubscription({...sub, limits:LIMITS[sub.tier]||LIMITS.starter, trialDaysLeft});
      } else if(isOwner) {
        // Only auto-grant trial for owners, not team members
        const BACKEND = process.env.REACT_APP_BACKEND_URL || "https://wholesaleiq-backend-production-aedc.up.railway.app";
        fetch(`${BACKEND}/api/auth/new-user`, {
          method: "POST",
          headers: {"Content-Type":"application/json"},
          body: JSON.stringify({ userId: user.id, email: user.email })
        }).catch(()=>{});
        const trialEnd = new Date();
        trialEnd.setDate(trialEnd.getDate() + 30);
        setSubscription({
          tier: "starter", status: "trialing", trial_end: trialEnd.toISOString(),
          trialDaysLeft: 30,
          limits: {leads:250, markets:1, rentcast:20, sms:0, members:1}
        });
      }
    }catch(e){console.warn("Subscription load error:",e);}
    })();
  },[user?.id]);

  if(checking)return(<div style={{background:"#0A0A0B",minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center"}}><div style={{width:32,height:32,border:"2px solid #1C1C1F",borderTopColor:"#C9A96E",borderRadius:"50%",animation:"spin .7s linear infinite"}}/><style>{"@keyframes spin{to{transform:rotate(360deg)}}"}</style></div>);
  if(!user)return <LoginPage onLogin={setUser}/>;
  if(role==="caller"||role==="cold_caller")return <IntakeForm/>;

  // ── Mobile: skip desktop shell, CRM handles its own nav ──────────────────────
  if(isMobile){
    // Wait for user.id to be resolved before mounting CRM
    if(!user?.id)return(<div style={{background:"#0A0A0B",minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:12}}><div style={{width:32,height:32,border:"2px solid #1C1C1F",borderTopColor:"#C9A96E",borderRadius:"50%",animation:"spin .7s linear infinite"}}/><div style={{fontSize:12,color:"#45454A",fontFamily:"'DM Mono',monospace",letterSpacing:2}}>LOADING...</div><style>{"@keyframes spin{to{transform:rotate(360deg)}}"}</style></div>);
    return(
      <div style={{height:"100vh",display:"flex",flexDirection:"column",background:"#0A0A0B",overflow:"hidden"}}>
        <TrialBanner subscription={subscription} currentUser={user}/>
        <CRM currentUser={user} onLogout={async()=>{await supabase.auth.signOut();setUser(null);}} initialSelectedLead={sel} onLeadsChange={setLeads} initialSubscription={subscription} initialLeads={leads}/>
      </div>
    );
  }

  // ── Desktop ───────────────────────────────────────────────────────────────────
  const _proActive = ["pro","team"].includes(subscription?.tier) && ["active","trialing"].includes(subscription?.status);
  const NAVS={
    owner:[
      ["dashboard","Dashboard"],
      ["crm","Pipeline"],
      ["prospects","Prospects"],
      ...(_proActive?[["outreach","Outreach"]]:[]),
      ["settings","Settings"],
    ],
    acquisitions:[
      ["dashboard","Dashboard"],
      ["crm","Pipeline"],
      ["prospects","Prospects"],
      ...(_proActive?[["outreach","Outreach"]]:[]),
    ],
    cold_caller:[],
    readonly:[["dashboard","Dashboard"]],
  };
  const NAV=NAVS[role]||NAVS.owner;
  const BADGES={owner:{l:"Owner",c:"#C06149"},acquisitions:{l:"Acquisitions",c:"#C9A96E"},cold_caller:{l:"Cold Caller",c:"#5A8A60"},readonly:{l:"Read Only",c:"#9B7ED4"}};
  const b=BADGES[role];

  return(
    <div style={{display:"flex",flexDirection:"column",height:"100vh",background:"#0A0A0B"}}>
      <div style={{display:"flex",alignItems:"center",background:"#0F0F11",borderBottom:"1px solid #1C1C1F",padding:"0 24px",height:52,flexShrink:0}}>
        <div style={{fontSize:22,letterSpacing:3,color:"#E8E6E1",marginRight:32,fontWeight:900}}>WHOLESALE<span style={{color:"#C9A96E"}}>IQ</span></div>
        <div style={{display:"flex",gap:2}}>
          {NAV.map(([id,label])=>(<button key={id} onClick={()=>setView(id)} style={{background:"none",border:"none",padding:"0 16px",height:52,fontSize:12,cursor:"pointer",color:view===id?"#C9A96E":"#45454A",borderBottom:view===id?"2px solid #C9A96E":"2px solid transparent"}}>{label}</button>))}
        </div>
        <div style={{marginLeft:"auto",display:"flex",alignItems:"center",gap:10}}>
          {b&&<span style={{fontSize:10,background:b.c+"18",color:b.c,borderRadius:4,padding:"2px 8px"}}>{b.l}</span>}
          <div style={{fontSize:11,color:"#45454A"}}>{leads.length} LEADS</div>
          <div style={{fontSize:12,color:"#2A2A2E"}}>{user.email}</div>

          <button onClick={async()=>{await supabase.auth.signOut();setUser(null);}} style={{background:"none",border:"1px solid #2A2A2E",borderRadius:6,color:"#6B6B70",padding:"5px 12px",cursor:"pointer",fontSize:11}}>SIGN OUT</button>
        </div>
      </div>

      <TrialBanner subscription={subscription} currentUser={user}/>
      <div style={{flex:1,overflow:"hidden",display:"flex"}}>
        {view==="dashboard"&&<Dashboard leads={leads} onSelectLead={(l)=>{setSel(l);setView("crm");}} onGoToCRM={()=>setView("crm")}/>}
        {view==="crm"&&role!=="readonly"&&teamReady&&<CRM currentUser={user} onLogout={async()=>{await supabase.auth.signOut();setUser(null);}} initialSelectedLead={sel} onLeadsChange={setLeads} initialSubscription={subscription} initialLeads={leads}/>}
        {view==="prospects"&&teamReady&&<Prospects currentUser={user} subscription={subscription} onGoToCRM={()=>setView("crm")}/>}
        {view==="outreach"&&<Outreach currentUser={user} subscription={subscription} onGoToCRM={()=>setView("crm")}/>}
        {view==="settings"&&role==="owner"&&<Settings currentUser={user} onUpgradeClick={()=>setShowUpgrade(true)} subscription={subscription}/>}
      </div>
    </div>
  );
}
